module.exports = __webpack_public_path__ + "static/media/icon_eye_closed.702f70b5.png";